import { Box, Typography, Stack, Divider } from "@mui/material";
import {
  CalendarMonth,
  InfoOutlined,
  ChatBubbleOutline,
  PaymentsOutlined,
} from "@mui/icons-material";

const SalaryDetailCard = ({ detail, index, total }) => {
  const formattedDate = detail.full_date
    ? new Date(detail.full_date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "—";

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #e2e8f0",
        background:
          index === 0
            ? "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)" // latest = highlighted
            : "linear-gradient(135deg, #f8faff 0%, #f1f5ff 100%)",
        position: "relative",
        transition: "box-shadow 0.2s",
        "&:hover": { boxShadow: "0 4px 12px rgba(59,91,219,0.1)" },
      }}
    >
      {/* Payment # badge */}

      <Stack spacing={1}>
        {/* Date + method */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <CalendarMonth sx={{ fontSize: 15, color: "#64748b" }} />
          <Typography
            sx={{ fontSize: "0.82rem", fontWeight: 600, color: "#1e293b" }}
          >
            {formattedDate}
          </Typography>
        </Box>
        {detail.payment_method && (
          <Box
            sx={{
              py: 0.3,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <PaymentsOutlined sx={{ fontSize: 13, color: "#3b5bdb" }} />
            <Typography
              sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#3b5bdb" }}
            >
              {detail.payment_method}
            </Typography>
          </Box>
        )}
        {/* Feedback */}
        {detail.feedback?.trim() && (
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.8 }}>
            <ChatBubbleOutline
              sx={{ fontSize: 14, color: "#94a3b8", mt: "2px" }}
            />
            <Typography sx={{ fontSize: "0.8rem", color: "#475569" }}>
              {detail.feedback}
            </Typography>
          </Box>
        )}

        {/* Extra info */}
        {detail.extra_information?.trim() && (
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.8 }}>
            <InfoOutlined sx={{ fontSize: 14, color: "#94a3b8", mt: "2px" }} />
            <Typography
              sx={{
                fontSize: "0.78rem",
                color: "#64748b",
                fontStyle: "italic",
              }}
            >
              {detail.extra_information}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

const ProfileSalaryDetails = ({ feedback }) => {
  // console.log("salary Details",feedback)
  const parsed = (() => {
    try {
      return Array.isArray(feedback) ? feedback : JSON.parse(feedback || "[]");
    } catch {
      return [];
    }
  })();

  // Descending order — most recent first
  const sorted = [...parsed].sort(
    (a, b) => new Date(b.full_date) - new Date(a.full_date),
  );

  if (sorted.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography variant="h6" color="text.secondary">
          Salary Payment History
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Stack spacing={1.5}>
        {sorted.map((detail, i) => (
          <SalaryDetailCard
            key={detail.full_date}
            detail={detail}
            index={i}
            total={sorted.length}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ProfileSalaryDetails;
